// types
import { FieldErrors, GroupDetails, RoleGroupItem } from "containers/NewGroup/useNewGroup";

// components
import { Form, Input } from "antd";
import Label from "components/atoms/Label/Label";

// styles
import styles from "components/organisms/NewGroup/newGroupDetails.module.css";

// constants
import { NewGroup as Constants, ViewMode } from "constants/global";
import ErrorMessage from "components/molecules/ErrorMessage/ErrorMessage";

type NewGroupDetailsProps = {
	mode?: string;
	initialValues?: {
		name: string;
		description: string;
		selectedRoles: string[];
	};
	groupDetails: GroupDetails;
	fieldErrors?: FieldErrors;
	validateFields: (arg: boolean) => void;
	handleGroupDetailsChange: ({ id, value }: RoleGroupItem) => void;
};

const NewGroupDetails = ({ mode, validateFields, initialValues, groupDetails, fieldErrors, handleGroupDetailsChange }: NewGroupDetailsProps) => {
	const readOnly = mode === ViewMode.READ;
	const disabled = readOnly || mode === ViewMode.EDIT;

	const groupNameClass = fieldErrors?.name ? styles?.err : styles?.filled;
	const groupDescClass = fieldErrors?.description ? styles?.err : styles?.filled;

	const handleChange = (e: { target: { id: any; value: any } }) => {
		handleGroupDetailsChange({
			id: e?.target?.id,
			value: e?.target?.value
		});
	};

	return (
		<Form className={styles?.form} requiredMark={false} layout="vertical">
			<div>
				<Form.Item
					extra={fieldErrors?.name && <ErrorMessage classes={styles?.err_message} message={Constants.INVALID_GROUP_NAME} />}
					name={Constants.FIELD_NAME}
					initialValue={initialValues?.name}
					label={<Label label={Constants.GROUP_NAME_LABEL} classes={{ label: styles?.basic_input_label }} requiredMark />}
				>
					<Input
						data-testid={Constants.FIELD_NAME}
						disabled={disabled}
						placeholder={Constants.GROUP_NAME_PLACEHOLDER}
						className={`${styles?.basic_input} ${groupDetails?.name ? groupNameClass : ""}`}
						value={groupDetails?.name}
						onChange={handleChange}
						onBlur={() => {
							validateFields(false);
						}}
					/>
				</Form.Item>
				<Form.Item
					extra={fieldErrors?.description && <ErrorMessage classes={styles?.err_message} message={Constants.INVALID_GROUP_DESC} />}
					name={Constants?.FIELD_DESCRIPTION}
					initialValue={initialValues?.description}
					label={<Label label={Constants.GROUP_DESCRIPTION_LABEL} classes={{ label: styles?.basic_input_label }} requiredMark />}
				>
					<Input
						data-testid={Constants?.FIELD_DESCRIPTION}
						readOnly={readOnly}
						placeholder={Constants.GROUP_DESC_PLACEHOLDER}
						className={`${styles?.basic_input} ${groupDetails?.description ? groupDescClass : ""}`}
						value={groupDetails?.description}
						onChange={handleChange}
						onBlur={() => {
							validateFields(false);
						}}
					/>
				</Form.Item>
			</div>
		</Form>
	);
};

export default NewGroupDetails;
